import * as React from 'react';
import {View} from 'react-native';
import {isEmpty} from 'lodash/fp';

import InlineFormattedNumber from '/component/base/FormattedNumber/InlineFormattedNumber';
import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {
  getStyles,
  getWCBalance,
} from '/component/partial/reportCard/ExpiringWellnessCreditsReportContent/ExpiringWellnessCreditsReportContent.util';
import {UserProfileModal} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {getDateUtilDefaultInstance} from '/util/date.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './ExpiringWellnessCreditsReportContent.style';
interface WellnessCreditHistoryItem {
  expiresOn: string;
  value: number;
}
interface Props {
  tt: (key: string, defaultValue?: string) => string;
  recordData: {
    wellnessCredits: {
      currencyCode: string;
      history: WellnessCreditHistoryItem[];
    };
  };
}

export const ExpiringWellnessCreditsReportContent: React.FC<Props> = ({
  tt,
  recordData,
}) => {
  const {
    wellnessCredits: {currencyCode, history},
  } = recordData;

  const wcBalance = getWCBalance({history})();

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text
            testID={UserProfileModal.totalExpiringWellnessCreditsTitle}
            emphasis="low"
            style={styles.heading}
            variant="subheading">
            {tt('title', 'Total expiring wellness Credits in the next 14 days')}
          </Text>
          <InlineFormattedNumber
            testID={UserProfileModal.totalExpiringWellnessCreditsValue}
            textVariant="xLarge"
            style={styles.balance}
            value={wcBalance}
            decimalPlaces={2}
            currencyCode={currencyCode}
          />
        </Gutter>
        <Gutter>
          <ListItem
            {...testProperties(null, true)}
            readonly={true}
            label={
              <Text testID={UserProfileModal.expirationSubtitle}>
                {tt('expiration', 'Expiration')}
              </Text>
            }
            suffix={
              <Text testID={UserProfileModal.amountSubtitle}>
                {tt('amount', 'Amount')}
              </Text>
            }
          />
        </Gutter>
      </View>

      {isEmpty(history) ? (
        <Gutter>
          <ListItem
            {...testProperties(null, true)}
            label={
              <Text
                emphasis="low"
                testID={UserProfileModal.expiringWellnessCreditsEmptyMessage}>
                {tt(
                  'noExpiringWellnessCredits',
                  'No Expiring Wellness Credits',
                )}
              </Text>
            }
            readonly={true}
            style={{base: styles.listItem}}
          />
        </Gutter>
      ) : (
        history.map(({expiresOn, value}) => (
          <Gutter key={`${expiresOn}${value}`}>
            <ListItem
              {...testProperties(null, true)}
              style={{base: styles.listItem}}
              readonly={true}
              label={
                <View>
                  <Text
                    style={getStyles({expiresOn})()}
                    testID={UserProfileModal.expiringWellnessCreditsDate}>
                    {getDateUtilDefaultInstance().formatRelativeDate(
                      expiresOn,
                      'MMMM d, yyyy',
                    )}
                  </Text>
                </View>
              }
              suffix={
                <InlineFormattedNumber
                  testID={UserProfileModal.expiringWellnessCreditsValue}
                  value={value}
                  decimalPlaces={2}
                  currencyCode={currencyCode}
                />
              }
            />
          </Gutter>
        ))
      )}
    </View>
  );
};

export default withTranslation('reportCardContent.expiringWellnessClients')(
  ExpiringWellnessCreditsReportContent,
);
